import './LawCardsSkeleton.css'


const LawCardSkeleton = () => {
    // نستخدم الكلاسات التي تحاكي بنية law_card_compact
    return (
        <div className="law_card_skeleton">
            {/* رأس البطاقة: الأيقونة والعنوان المقتطع */}
            <div className="skeleton-header">
                {/* أيقونة وهمية */}
                <div className="skeleton-icon"></div> 
                <div className="skeleton-title-group">
                    <div className="skeleton-line skeleton-title-line"></div>
                    <div className="skeleton-line skeleton-subtitle-line"></div>
                </div>
            </div>

            {/* قسم البيانات الوصفية (Meta Data) */}
            <div className="skeleton-meta">
                <div className="skeleton-line skeleton-meta-line w-4/5"></div>
                <div className="skeleton-line skeleton-meta-line w-3/5"></div>
            </div>

            {/* زر عرض التفاصيل والحالة */}
            <div className="skeleton-footer">
                <div className="skeleton-line w-1/4 h-6 rounded-lg"></div> {/* الحالة */}
                <div className="skeleton-line w-1/3 h-8 rounded-lg"></div> {/* زر عرض التفاصيل */}
            </div>
        </div>
    );
};

// =============================================================
// مُكوّن الحاوية للعرض (لعرض 6 بطاقات هيكلية)
// =============================================================

export const LawsSkeletonLoader = ({ count = 6 }) => {
    // نستخدم نفس تنسيق الـ Grid الذي تستخدمه في وضع العرض العادي/المضغوط
    return (
        <div className="results_container_skeleton">
            {Array(count).fill(0).map((_, index) => (
                <LawCardSkeleton key={index} />
            ))}
        </div>
    );
};

export default LawsSkeletonLoader;